import { useState, useEffect } from 'react'
import { dateLoader, deleteDate } from '../apiCalls'
import { useParams } from 'react-router'
import { Link, useNavigate } from 'react-router-dom'
import EditDate from './editDate'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const ShowDate = (props) => {
    const { id } = useParams()

    const [date, setDate] = useState({})
    const [openDelete, setOpenDelete] = useState(false)
    const [dateEditToggle, setDateEditToggle] = useState(false)
    const navigate = useNavigate()

    async function getDate() {
        let thisDate = await dateLoader(id)
        let d = new Date(thisDate.date)
        let month = d.getUTCMonth() + 1
        let day = d.getUTCDate()
        let betterDate = `${month}/${day}`
        thisDate.date = betterDate
        thisDate.properDate = d
        setDate(thisDate)
    }

    function deleteToggle() {
        if (openDelete){
        setOpenDelete(false)
        } else {
            setOpenDelete(true)
        }
    }

    function editToggle() {
        if (dateEditToggle) {
            setDateEditToggle(false)
        } else {
            setDateEditToggle(true)
        }
    }

    async function handleDelete(e) {
        try{
            e.preventDefault()
            await deleteDate(id)
            navigate('/')
        } catch(err) {
            console.log(err)
        }

    }

    useEffect(() => {
        getDate()
    }, [])

    return (
        <Container className="dateDetailContainer">
            {dateEditToggle ? <EditDate mods={{setDateEditToggle, date, setDate, getDate}} /> : null}
            <div className="showDate">
                <h2>{date.name}</h2>
                <div>
                    <p className="d-inline-block me-4">Date: {date.date}</p>
                    <p className="d-inline-block me-4">Time: {date.time}</p>
                </div>
                <p>Location: {date.location}</p>
                <p>Details: {date.details}</p>
                <p>Person of Interest: {date.dateName}</p>
            </div>
            
                {(openDelete && !dateEditToggle) ? <>
                    <p className="d-inline-block mx-2 text-white">Are you sure?</p>
                    <Button onClick={handleDelete} className="d-inline-block mx-2 btn-danger defaultButton dangerButton">Yes</Button>
                    <Button onClick={deleteToggle} className="d-inline-block mx-2 btn-dark defaultButton">No</Button>
                    </> : <><Row className="my-3"><Col xs={3}><Button onClick={editToggle} className="btn-dark defaultButton editButton">Edit</Button></Col>
                    <Col xs={3}><Button onClick={deleteToggle} className="btn-danger defaultButton dangerButton">Delete</Button></Col></Row>
                    </>}
            <Row>
                <Link to={'/'}><Button variant="dark" className="d-block defaultButton"><i className="bi bi-arrow-left"></i> Back</Button></Link>
            </Row>
        </Container>
    )
}

export default ShowDate